// projectmini.us — shared site behavior
document.addEventListener("DOMContentLoaded", () => {

  // ---------- mobile nav toggle ----------
  const navToggle = document.getElementById("nav-toggle");
  const siteNav = document.getElementById("site-nav");
  if (navToggle && siteNav) {
    navToggle.addEventListener("click", () => siteNav.classList.toggle("open"));
  }

  // close mobile nav after a link is tapped (single-page anchor nav)
  document.querySelectorAll("#site-nav a").forEach((a) => {
    a.addEventListener("click", () => siteNav && siteNav.classList.remove("open"));
  });

  // scrollspy: highlight the current section's nav link as the page scrolls
  const navLinks = Array.from(document.querySelectorAll("#site-nav a"));
  const sections = navLinks
    .map((a) => document.querySelector(a.getAttribute("href")))
    .filter(Boolean);

  function setActiveByScroll() {
    const y = window.scrollY + 90;
    let current = sections[0];
    sections.forEach((sec) => { if (sec.offsetTop <= y) current = sec; });
    navLinks.forEach((a) => {
      const sec = document.querySelector(a.getAttribute("href"));
      a.classList.toggle("active", sec === current);
    });
  }
  if (sections.length) {
    setActiveByScroll();
    window.addEventListener("scroll", setActiveByScroll, { passive: true });
  }

  // ---------- color swatches (16-color palette, one active per card) ----------
  document.querySelectorAll(".swatches").forEach((group) => {
    const nameOut = group.parentElement.querySelector("[data-color-name]");
    group.querySelectorAll(".swatch").forEach((sw) => {
      sw.addEventListener("click", () => {
        group.querySelectorAll(".swatch").forEach((s) => s.classList.remove("selected"));
        sw.classList.add("selected");
        if (nameOut) nameOut.textContent = sw.getAttribute("title") || "";
      });
    });
  });

  // ---------- lens tint picker (white/yellow, visual only, no price impact) ----------
  document.querySelectorAll(".light-tint-row").forEach((row) => {
    row.querySelectorAll(".tint-btn").forEach((btn) => {
      btn.addEventListener("click", () => {
        row.querySelectorAll(".tint-btn").forEach((b) => b.classList.remove("selected"));
        btn.classList.add("selected");
      });
    });
  });

  // ---------- baja/wheelie light checkboxes: toggle their own tint row ----------
  document.querySelectorAll("[data-light-toggle]").forEach((cb) => {
    const card = cb.closest("[data-product-card]");
    const key = cb.dataset.lightToggle;
    const tintRow = card ? card.querySelector(`.light-tint-row[data-light-tint="${key}"]`) : null;
    function syncTint() {
      if (tintRow) tintRow.style.display = cb.checked ? "flex" : "none";
    }
    cb.addEventListener("change", syncTint);
    syncTint();
  });

  // ---------- product variant/add-on price totals ----------
  document.querySelectorAll("[data-product-card]").forEach((card) => {
    const base = parseFloat(card.dataset.basePrice || "0");
    const totalEl = card.querySelector("[data-total]");
    const checkboxes = card.querySelectorAll("input[type=checkbox][data-addon-price]");

    function recalc() {
      let sum = base;
      checkboxes.forEach((cb) => {
        if (cb.checked) sum += parseFloat(cb.dataset.addonPrice || "0");
      });
      if (totalEl) totalEl.textContent = "$" + sum.toFixed(2);
    }
    checkboxes.forEach((cb) => cb.addEventListener("change", recalc));
    card.querySelectorAll("select.vselect").forEach((sel) => {
      sel.addEventListener("change", recalc);
    });
    if (totalEl) recalc();
  });

  // ---------- real Shopify cart: /cart/add.js + header cart count ----------
  // NOTE: these calls only succeed once this page is actually served from your
  // Shopify domain (same-origin requirement of the Storefront AJAX Cart API).
  // Opened as a standalone file/preview, "Add to Cart" will fail with a network
  // error — that's expected, not a bug.
  const cartCountEl = document.getElementById("cart-count");

  function refreshCartCount() {
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then((r) => (r.ok ? r.json() : null))
      .then((cart) => {
        if (!cart || !cartCountEl) return;
        cartCountEl.textContent = cart.item_count;
        cartCountEl.style.display = cart.item_count > 0 ? "flex" : "none";
      })
      .catch(() => {}); // silently ignore off-Shopify preview
  }
  refreshCartCount();

  function pickedVariantId(card) {
    // multi-option products (e.g. fingerboards: Design x Size): two or more
    // <select data-variant-combo> pickers whose values combine ("a|b|...")
    // into a lookup key against the card's data-variant-map JSON.
    const comboSelects = card.querySelectorAll("select[data-variant-combo]");
    if (comboSelects.length) {
      let map = {};
      try { map = JSON.parse(card.dataset.variantMap || "{}"); } catch (e) { map = {}; }
      const key = Array.from(comboSelects).map((s) => s.value).join("|");
      return map[key] || "";
    }
    // bike cards: selected color swatch. merch cards: a size <select> or a
    // fixed hidden input, depending on whether the product has size variants.
    const selectedSwatch = card.querySelector(".swatch.selected");
    if (selectedSwatch) return selectedSwatch.dataset.variantId || "";
    const sizeSelect = card.querySelector("select[data-variant-select]");
    if (sizeSelect) return sizeSelect.value || "";
    const fixed = card.querySelector("input[data-variant-id]");
    if (fixed) return fixed.dataset.variantId || "";
    return "";
  }

  function collectAddonVariantIds(card) {
    const ids = [];
    card.querySelectorAll("input[type=checkbox][data-addon-price]:checked").forEach((cb) => {
      if (cb.dataset.lightToggle) {
        // baja/wheelie light: which variant depends on the selected lens tint
        const tintRow = card.querySelector(`.light-tint-row[data-light-tint="${cb.dataset.lightToggle}"]`);
        const tint = tintRow && tintRow.querySelector(".tint-btn.selected") ? tintRow.querySelector(".tint-btn.selected").dataset.tint : "white";
        const vid = tint === "yellow" ? cb.dataset.variantYellow : cb.dataset.variantWhite;
        if (vid) ids.push(vid);
      } else if (cb.dataset.addonVariant) {
        ids.push(cb.dataset.addonVariant);
      }
    });
    return ids;
  }

  document.querySelectorAll("[data-add-to-cart]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const card = btn.closest("[data-product-card]");
      if (!card) return;
      const msgEl = card.querySelector("[data-cart-msg]");
      const showMsg = (text, ok) => {
        if (!msgEl) return;
        msgEl.textContent = "";
        msgEl.className = "cart-msg " + (ok ? "ok" : "err");
        msgEl.style.display = "block";
        msgEl.appendChild(document.createTextNode(text));
        if (ok) {
          const link = document.createElement("a");
          link.href = "/cart";
          link.className = "cart-msg-link";
          link.textContent = "View Cart →";
          msgEl.appendChild(link);
        }
      };

      const variantId = pickedVariantId(card);
      if (!variantId) {
        showMsg("Couldn't find a variant for the selected option.", false);
        return;
      }
      const items = [{ id: variantId, quantity: 1 }];
      collectAddonVariantIds(card).forEach((vid) => items.push({ id: vid, quantity: 1 }));

      btn.disabled = true;
      const originalLabel = btn.textContent;
      btn.textContent = "Adding…";

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items }),
      })
        .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
        .then(({ ok, data }) => {
          if (ok) {
            showMsg("Added to cart ✓", true);
            refreshCartCount();
          } else {
            showMsg((data && data.description) || "Couldn't add to cart — check the variant IDs.", false);
          }
        })
        .catch(() => {
          showMsg("Cart request failed (this preview isn't running on your Shopify domain, so /cart/add.js can't be reached — this will work once deployed).", false);
        })
        .finally(() => {
          btn.disabled = false;
          btn.textContent = originalLabel;
        });
    });
  });

  // ---------- before / after sliders ----------
  document.querySelectorAll(".ba-slider").forEach((slider) => {
    const after = slider.querySelector(".ba-after");
    const handle = slider.querySelector(".ba-handle");
    let dragging = false;

    function setPos(clientX) {
      const rect = slider.getBoundingClientRect();
      let pct = ((clientX - rect.left) / rect.width) * 100;
      pct = Math.max(0, Math.min(100, pct));
      after.style.clipPath = `inset(0 ${100 - pct}% 0 0)`;
      handle.style.left = pct + "%";
    }
    setPos(slider.getBoundingClientRect().left + slider.getBoundingClientRect().width / 2);

    slider.addEventListener("pointerdown", (e) => { dragging = true; setPos(e.clientX); });
    window.addEventListener("pointermove", (e) => { if (dragging) setPos(e.clientX); });
    window.addEventListener("pointerup", () => (dragging = false));
    slider.addEventListener("touchstart", (e) => setPos(e.touches[0].clientX), { passive: true });
    slider.addEventListener("touchmove", (e) => setPos(e.touches[0].clientX), { passive: true });
  });

  // ---------- upgrade picker (swaps before/after photos or labels + shop links) ----------
  function parseLinks(str) {
    if (!str) return [];
    return str.split("|||").filter(Boolean).map((pair) => {
      const idx = pair.indexOf("::");
      return { label: pair.slice(0, idx), url: pair.slice(idx + 2) };
    });
  }

  function applyUpgradeButton(btn, slider, linksOut, nameOut, priceOut) {
    if (slider) {
      const beforeImg = slider.querySelector(".ba-before .ba-photo");
      const afterImg = slider.querySelector(".ba-after .ba-photo");
      const beforeLabel = slider.querySelector(".ba-before .label");
      const afterLabel = slider.querySelector(".ba-after .label");
      const beforeSrc = btn.dataset.beforeImg || "";
      const afterSrc = btn.dataset.afterImg || "";

      if (beforeImg) {
        if (beforeSrc) { beforeImg.src = beforeSrc; beforeImg.style.display = "block"; }
        else { beforeImg.style.display = "none"; }
      }
      if (afterImg) {
        if (afterSrc) { afterImg.src = afterSrc; afterImg.style.display = "block"; }
        else { afterImg.style.display = "none"; }
      }
      if (beforeLabel) { beforeLabel.textContent = btn.dataset.before || "Before"; beforeLabel.style.display = beforeSrc ? "none" : "block"; }
      if (afterLabel) { afterLabel.textContent = btn.dataset.after || "After"; afterLabel.style.display = afterSrc ? "none" : "block"; }
    }
    if (nameOut) nameOut.textContent = btn.dataset.name || btn.textContent;
    if (priceOut) priceOut.textContent = btn.dataset.price || "";
    if (linksOut) {
      const links = parseLinks(btn.dataset.links);
      linksOut.innerHTML = links
        .map((l) => `<a href="${l.url}" class="btn btn-primary" ${/^https?:\/\//.test(l.url) ? 'target="_blank" rel="noopener"' : ""}>${l.label}</a>`)
        .join("");
    }
  }

  document.querySelectorAll("[data-ba-picker]").forEach((picker) => {
    const group = picker.dataset.baPicker;
    const slider = document.querySelector(`.ba-slider[data-ba-target="${group}"]`);
    const linksOut = document.querySelector(`[data-ba-shoplinks="${group}"]`);
    const nameOut = document.querySelector(`[data-ba-name="${group}"]`);
    const priceOut = document.querySelector(`[data-ba-price="${group}"]`);

    const initialBtn = picker.querySelector("button.active") || picker.querySelector("button");
    if (initialBtn) applyUpgradeButton(initialBtn, slider, linksOut, nameOut, priceOut);

    picker.querySelectorAll("button").forEach((btn) => {
      btn.addEventListener("click", () => {
        picker.querySelectorAll("button").forEach((b) => b.classList.remove("active"));
        btn.classList.add("active");
        applyUpgradeButton(btn, slider, linksOut, nameOut, priceOut);
      });
    });
  });

  // ---------- track your mini lookup (demo data, no backend yet) ----------
  const trackForm = document.getElementById("track-form");
  if (trackForm) {
    trackForm.addEventListener("submit", (e) => {
      e.preventDefault();
      const orderInput = document.getElementById("track-order").value.trim();
      const result = document.getElementById("track-result");
      const err = document.getElementById("track-error");
      const steps = ["step-placed", "step-production", "step-shipped", "step-delivered"];

      if (!orderInput) {
        err.textContent = "Enter an order number to look up your build.";
        err.style.display = "block";
        result.style.display = "none";
        return;
      }
      err.style.display = "none";
      result.style.display = "block";

      // demo logic: order number's last digit decides how far along the mock build is
      const lastDigit = parseInt(orderInput.replace(/\D/g, "").slice(-1) || "2", 10);
      const doneCount = 1 + (lastDigit % 4);
      steps.forEach((id, i) => {
        const el = document.getElementById(id);
        if (el) el.classList.toggle("done", i < doneCount);
      });
      document.getElementById("track-order-echo").textContent = orderInput;
    });
  }

  // ---------- contact form ----------
  // Real Shopify contact form (action="/contact#contact_form", form_type=contact
  // hidden field) — this submits natively to Shopify and doesn't need JS. In this
  // standalone preview the action target doesn't exist, so submitting will just
  // show a browser navigation error; that resolves itself once deployed on your
  // Shopify domain, where Shopify redirects back with a thank-you state.
});
